<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="destino">
    <fieldset id="agregar_destino" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <h3 class="form-signin-heading"><strong>Destino(s) Contemplado(s):</strong></h3>
                            <hr />
                            <div class="form-group col-md-12 check-content">
                                
                                <div class="col-md-4" style="margin-top: 14px">
                                    <mat-checkbox (change)="add_destino()" formControlName="residencial" name="residencial" value="SI">Residencial Art. 2.1.25 OGUC</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <label for="dest" style="padding-bottom: 20px; padding-top: 15px;">Destino Especifico</label>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino" id="destino_resd" name="destino_resd" formControlName="destino_resd" (change)="add_destino()" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group col-md-12 check-content">
                                <div class="form-group col-md-12">
                                
                                    <div class="col-md-4" style="margin-top: 14px">
                                        <mat-checkbox (change)="add_destino()" formControlName="equipamiento" name="equipamiento" (change)="add_destino()" value="SI">Equipamiento Art. 2.1.33 OGUC</mat-checkbox>
                                    </div>
                                    <div class="col-md-4">
                                        <label for="dest" style="padding-bottom: 20px; padding-top: 15px; padding-left: 10px">Clase Art.2.1.33 OGUC</label>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field class="example-full-width" style="width: 145px; padding-left: 20px">
                                            <input matInput placeholder="Clase" id="clase_eq" name="clase_eq" formControlName="clase_eq" (change)="add_destino()" >
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-group col-md-12">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <label for="dest" style="padding-bottom: 20px; padding-top: 15px; padding-left: 10px">Actividad</label>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field class="example-full-width" style="width: 145px; padding-left: 20px">
                                            <input matInput placeholder="Actividad" id="actividad_eq" name="actividad_eq" formControlName="actividad_eq" (change)="add_destino()" >
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="form-group col-md-12">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <label for="dest" style="padding-bottom: 20px; padding-top: 15px; padding-left: 10px">Escala Art.2.1.36 OGUC</label>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-form-field class="example-full-width" style="width: 145px; padding-left: 20px">
                                            <input matInput placeholder="Escala" id="escala_eq" name="escala_eq" formControlName="escala_eq" (change)="add_destino()" >
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-12 check-content">
                                
                                <div class="col-md-4" style="margin-top: 14px">
                                    <mat-checkbox (change)="add_destino()" formControlName="actividad" name="actividad" value="SI">Activ. Productivas Art. 2.1.28 OGUC</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <label for="dest" style="padding-bottom: 20px; padding-top: 15px;">Destino Especifico</label>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino" id="destino_act" name="destino_act" formControlName="destino_act" (change)="add_destino()" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group col-md-12 check-content">
                                <div class="col-md-4" style="margin-top: 14px">
                                    <mat-checkbox (change)="add_destino()" formControlName="infraestructura" name="infraestructura" value="SI">Infraestructura Art. 2.1.29 OGUC</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <label for="dest" style="padding-bottom: 20px; padding-top: 15px;">Destino Especifico</label>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino" id="destino_infr" name="destino_infr" formControlName="destino_infr" (change)="add_destino()" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group col-md-12 check-content">
                                <div class="col-md-4" style="margin-top: 14px">
                                    <mat-checkbox (change)="add_destino()" formControlName="otros" name="otros" value="SI">Otros</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <label for="dest" style="padding-bottom: 20px; padding-top: 15px;">Especificar</label>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Otros" id="esp_otros" name="esp_otros" formControlName="esp_otros" (change)="add_destino()" >
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <br />
        </div>
    </fieldset>
</div>
<div class="separator"></div>